export default __webpack_public_path__ + "static/media/mail.d592e18a.svg";